import { Component } from '@angular/core';
import { COLUMNS_HEADER_BLENDERS_ADMIN } from '../../core/constants/tables.constants';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { BlendersService } from '../../core/services/blenders.service';
import { ValueStream } from '../../core/enums/general.enum';

@Component({
  selector: 'app-blenders',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, FormsModule, ReactiveFormsModule, GenericTableComponent, SpinnerComponent],
  templateUrl: './blenders.component.html',
  styleUrl: './blenders.component.scss'
})
export class BlendersComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_BLENDERS_ADMIN;
  valueStreamValues = Object.values(ValueStream);

  blenders: any;
  blendersFiltered: any;

  filters: any = {
    value_stream: {
      value: '',
      filter: (obj: any): boolean => obj.value_stream === this.filters.value_stream.value
    },
  };

  isModalActive = false;
  isLoading = false;
  isCreating = false;
  isDeleting = false;

  faSpinner = faSpinner;

  form: FormGroup = this.formBuilder.group({
    id: [, Validators.required],
    description: ['', Validators.required],
    value_stream: ['', Validators.required],
    active: [false, Validators.required]
  });

  constructor(
    private blendersSvc: BlendersService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {
    await this.getBlenders();
  }

  async onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getBlenders();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El blender ${this.form.value.code} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El blender ${this.form.value.code} ha sido actualizado correctamente`);
        }
        this.form.reset();
      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
       this.blendersSvc.createBlender(this.form.value).subscribe(responseAction);
      } else {
       this.blendersSvc.updateBlender(this.form.value).subscribe(responseAction);
      }
    }

  }

  async getBlenders() {
    this.blendersSvc.getBlenders().subscribe((res: any) => {
      this.blenders = res;
      this.blendersFiltered = res;
    });
  }

  onFilter() {
    this.blendersFiltered = this.blenders.filter((obj: any) => {
      return Object.keys(this.filters).map(f =>
        !this.filters[f].value ? true : this.filters[f].filter(obj)
      ).every(f => f);
    });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.blendersSvc.deleteBlender(item.id).subscribe({
      next: () => {
        this.getBlenders();
        this.isLoading = false;
        this.toastr.success(`El blender ${item.id} ha sido eliminado correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

}
